// extracted by mini-css-extract-plugin
export default {"blankStateWrapper":"xgf2eFaYVSvyzGd9P4aM","largeIcon":"If3L9XqkmQiN9pmZnprr","extraContent":"NqBKxY43YErIIyIOWDXA","btnInlineCenter":"YWmxavDcQnjSGTnhLzzA"};